module.exports = __webpack_public_path__ + "media/images/countryrect/mw-e1bf2cdb15e5ff9e66362188c9974f3a.svg";